(() => {
  'use strict';

  const panel = document.querySelector('[data-dl-cookie-consent]');
  if (!panel) return;

  const form = panel.querySelector('[data-dl-cookie-form]');
  const preferences = panel.querySelector('[data-dl-cookie-preferences]');
  const analytics = panel.querySelector('[data-dl-cookie-analytics]');
  const marketing = panel.querySelector('[data-dl-cookie-marketing]');
  const acceptButton = panel.querySelector('[data-dl-cookie-accept]');
  const necessaryButton = panel.querySelector('[data-dl-cookie-necessary]');
  const saveButton = panel.querySelector('[data-dl-cookie-save]');
  const closeButton = panel.querySelector('[data-dl-cookie-close]');
  const status = panel.querySelector('[data-dl-cookie-status]');
  const forceOpen = new URLSearchParams(window.location.search).get('dl-cookie-settings') === '1';
  const storageKey = 'dl_cookie_consent_saved_v1';

  let privacyApi = null;
  let isSaving = false;
  let hideTimer = null;

  const setStatus = (message = '', isError = false) => {
    if (!status) return;
    status.textContent = message;
    status.classList.toggle('is-error', isError);
  };

  const setButtonsDisabled = (disabled) => {
    [acceptButton, necessaryButton, saveButton].forEach((button) => {
      if (button) button.disabled = disabled;
    });
  };

  const showPanel = (allowClose = false) => {
    if (hideTimer !== null) {
      window.clearTimeout(hideTimer);
      hideTimer = null;
    }
    panel.hidden = false;
    if (closeButton) closeButton.hidden = !allowClose;
    window.requestAnimationFrame(() => panel.classList.add('is-visible'));
  };

  const hidePanel = () => {
    panel.classList.remove('is-visible');
    if (hideTimer !== null) window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(() => {
      panel.hidden = true;
      hideTimer = null;
    }, 190);
  };

  const readConsent = () => {
    if (!privacyApi || typeof privacyApi.currentVisitorConsent !== 'function') {
      return {marketing: '', analytics: '', preferences: ''};
    }
    return privacyApi.currentVisitorConsent() || {marketing: '', analytics: '', preferences: ''};
  };

  const applyConsentToControls = (consent) => {
    preferences.checked = consent.preferences === 'yes';
    analytics.checked = consent.analytics === 'yes';
    marketing.checked = consent.marketing === 'yes';
  };

  const saveConsent = (values) => {
    if (!privacyApi || typeof privacyApi.setTrackingConsent !== 'function' || isSaving) {
      setStatus('Die Datenschutzeinstellungen werden noch geladen. Bitte versuchen Sie es erneut.', true);
      return;
    }

    isSaving = true;
    setButtonsDisabled(true);
    setStatus('Auswahl wird gespeichert …');

    privacyApi.setTrackingConsent(values, (result) => {
      isSaving = false;
      setButtonsDisabled(false);

      if (result && result.error) {
        setStatus('Die Auswahl konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.', true);
        return;
      }

      try {
        window.localStorage.setItem(storageKey, '1');
      } catch (error) {
        // Consent remains stored by Shopify even when localStorage is unavailable.
      }

      setStatus('Ihre Auswahl wurde gespeichert.');
      document.dispatchEvent(new CustomEvent('dl:cookie-consent-saved', {detail: values}));
      window.setTimeout(hidePanel, 350);
    });
  };

  acceptButton?.addEventListener('click', () => {
    preferences.checked = true;
    analytics.checked = true;
    marketing.checked = true;
    saveConsent({preferences: true, analytics: true, marketing: true});
  });

  necessaryButton?.addEventListener('click', () => {
    preferences.checked = false;
    analytics.checked = false;
    marketing.checked = false;
    saveConsent({preferences: false, analytics: false, marketing: false});
  });

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    saveConsent({
      preferences: preferences.checked,
      analytics: analytics.checked,
      marketing: marketing.checked,
    });
  });

  closeButton?.addEventListener('click', hidePanel);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dl-cookie-settings]');
    if (!trigger) return;

    if (window.location.pathname !== '/') return;

    event.preventDefault();
    const consent = readConsent();
    applyConsentToControls(consent);
    showPanel(true);
  });

  const initialise = () => {
    privacyApi = window.Shopify?.customerPrivacy || null;
    if (!privacyApi) return false;

    const consent = readConsent();
    applyConsentToControls(consent);
    setButtonsDisabled(false);

    let documentloadConsentSaved = false;
    try {
      documentloadConsentSaved = window.localStorage.getItem(storageKey) === '1';
    } catch (error) {
      documentloadConsentSaved = false;
    }

    if (forceOpen) {
      showPanel(true);
      return true;
    }

    // Never infer an active visitor decision from Shopify's technical yes/no
    // defaults. Only the Documentload marker set after a real button click
    // controls whether the first-view panel remains hidden.
    if (!documentloadConsentSaved) {
      showPanel(false);
    }

    return true;
  };

  const hasDocumentloadDecision = () => {
    try {
      return window.localStorage.getItem(storageKey) === '1';
    } catch (error) {
      return false;
    }
  };

  // Visibility is controlled only by the explicit Documentload decision marker.
  // Shopify may expose technical yes/no defaults before the visitor has actively
  // used this interface; those values must never suppress the first display.
  setButtonsDisabled(true);
  if (forceOpen || !hasDocumentloadDecision()) {
    showPanel(forceOpen);
  }

  if (initialise()) return;

  document.addEventListener('shopifyCustomerPrivacyApiLoaded', initialise, {once: true});

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{name: 'consent-tracking-api', version: '0.1'}],
      (error) => {
        if (error || !initialise()) {
          showPanel(false);
          setStatus('Die Datenschutzeinstellungen konnten noch nicht geladen werden. Bitte laden Sie die Seite neu.', true);
        }
      },
    );
  } else {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (initialise() || attempts >= 30) {
        window.clearInterval(timer);
        if (!privacyApi) {
          showPanel(false);
          setStatus('Die Datenschutzeinstellungen konnten noch nicht geladen werden. Bitte laden Sie die Seite neu.', true);
        }
      }
    }, 200);
  }
})();
